// NBN Edit Form Constants
// Static data that doesn't need to be reactive

export const BANDWIDTH_PROFILES = {
NCAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U5-10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D25-50_U5-20_Mbps_TC4_P", disabled: false },
    { text: "100/20 Mbps", value: "Home Fast", disabled: false },
    {
    text: "100/40 Mbps",
    value: "D25-100_U5-40_Mbps_TC4_P",
    disabled: false
    }
],

NWAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "FW Plus", value: "FWPlus_TC4_P", disabled: false },
    { text: "250/20 Mbps", value: "FW Home Fast", disabled: false },
    { text: "400/40 Mbps", value: "FW Superfast", disabled: false }
],

NHAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D50_U20_Mbps_TC4_P", disabled: false },
    { text: "100/40 Mbps", value: "D100_U40_Mbps_TC4_P", disabled: false },
    { text: "250/100 Mbps", value: "D250_U100_Mbps_TC4_P", disabled: false },
    { text: "500/50 Mbps", value: "Home Fast", disabled: false },
    { text: "750/50 Mbps", value: "Home Superfast", disabled: false },
    { text: "1000/100 Mbps", value: "Home Ultrafast", disabled: false }
],

NFAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D50_U20_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D25-50_U5-20_Mbps_TC4_P", disabled: false },
    { text: "100/40 Mbps", value: "D25-100_U5-40_Mbps_TC4_P", disabled: false },
    { text: "100/40 Mbps", value: "D100_U40_Mbps_TC4_P", disabled: false },
    { text: "250/100 Mbps", value: "D250_U100_Mbps_TC4_P", disabled: false },
    {text: "500/200 Mbps",value: "D500_U200_Mbps_TC4_P",disabled: false},
    { text: "500/50 Mbps", value: "Home Fast", disabled: false },
    { text: "750/50 Mbps", value: "Home Superfast", disabled: false },
    { text: "1000/100 Mbps", value: "Home Ultrafast", disabled: false },
    { text: "1000/400 Mbps", value: "D1000_U400_Mbps_TC4_P", disabled: false },
],

FTTC_NCAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D50_U20_Mbps_TC4_P", disabled: false },
    { text: "100/20 Mbps", value: "Home Fast", disabled: false },
    {
    text: "100/40 Mbps",
    value: "D50-100_U20-40_Mbps_TC4_P",
    disabled: false
    },
    {
    text: "50/20 Mbps",
    value: "D25-50_U5-20_Mbps_TC4_P",
    disabled: false,
    obsolete: true
    }
]
};

// Helper function to get bandwidth profiles by product type
export function getBandwidthProfilesByProductType(productType) {
    switch (productType) {
        case "FTTB":
        case "FTTN":
        return BANDWIDTH_PROFILES.NCAS;
        case "Fixed Wireless":
        return BANDWIDTH_PROFILES.NWAS;
        case "HFC":
        return BANDWIDTH_PROFILES.NHAS;
        case "FTTC":
        return BANDWIDTH_PROFILES.FTTC_NCAS;
        case "Fibre":
        case "FTTP":
        return BANDWIDTH_PROFILES.NFAS;
        default:
        return [];
    }
}

export function resolveBandwidthProfileKey(primaryAccessTechnology, productType) {
    const typeMap = {
        NFAS: 'NFAS',
        NCAS: 'NCAS',
        FTTC: 'FTTC_NCAS',
        NWAS: 'NWAS',
        NHAS: 'NHAS',
    };

    if (productType && typeMap[productType]) {
        return typeMap[productType];
    }

    const tech = (primaryAccessTechnology || '').toLowerCase();

    if (tech.includes('fibre to the premises') || tech === 'fibre' || tech === 'fttp') {
        return 'NFAS';
    }
    if (tech.includes('fibre to the building') || tech === 'fttb' || tech.includes('fibre to the node') || tech === 'fttn') {
        return 'NCAS';
    }
    if (tech.includes('fibre to the curb') || tech === 'fttc') {
        return 'FTTC_NCAS';
    }
    if (tech.includes('wireless') || tech === 'fixed wireless') {
        return 'NWAS';
    }
    if (tech.includes('hfc')) {
        return 'NHAS';
    }

    return null;
}

export function getMaxBandwidthProfileText(profileKey, availableTierValues = []) {
    const profiles = BANDWIDTH_PROFILES[profileKey];
    if (!profiles?.length || !availableTierValues?.length) {
        return 'Not Available';
    }

    const available = new Set(availableTierValues);
    let maxText = null;
    let maxIndex = -1;

    profiles.forEach((profile, index) => {
        if (profile.obsolete) return;
        if (!available.has(profile.value)) return;

        if (index > maxIndex) {
        maxIndex = index;
        maxText = profile.text;
        }
    });

    return maxText || 'Not Available';
}